import { createReducer } from '@reduxjs/toolkit';
import omit from 'lodash/omit';

import {
  ActionSuccessType,
  DELETE_CALENDAR_ACCOUNT,
  CREATE_SESSION,
  DELETE_SESSION,
  GET_EXPERT_GLOBAL_SETTINGS,
  GET_EXPERT_SETTINGS,
  UPDATE_CALENDAR_CONFIGURATIONS,
  UPDATE_EXPERT_DETAILS,
  UPDATE_SESSION,
  UPDATE_VACATION_MODE,
  UPDATE_EXPERT_AVAILABILITY,
  CREATE_TIME_SLOT,
  REMOVE_TIME_SLOT,
  UPDATE_GIFT_CARD_SETTING,
  UPDATE_SESSION_SETTINGS,
  CREATE_SESSION_PACK,
  UPDATE_SESSION_PACK,
  DELETE_SESSION_PACK,
  UPDATE_PAYOUT_METHOD,
  DISCONNECT_ZOOM_ACCOUNT,
  UPDATE_ZOOM_CONFIGURATIONS,
  ENABLE_ZOOM_CO_HOST,
  GET_EXPERT_SESSIONS_SETTING,
  UPDATE_CURRENCY_LIMITATIONS,
  UPDATE_EXPERT_VISIBILITY,
  GET_IN_PERSON_MEETING_LOCATIONS,
  UPDATE_IN_PERSON_MEETING_LOCATIONS,
  GET_EXPERT_PACKAGES,
  GET_EXPERT_AVAILABLE_STRIPE_ACCOUNTS,
} from 'constants/redux-actions';

const initState = {};

const expertSettingsReducer = createReducer(initState, {
  [ActionSuccessType(GET_EXPERT_SETTINGS)]: (prev, action) => ({ ...prev, ...action.payload.data }),
  [ActionSuccessType(UPDATE_EXPERT_DETAILS)]: (prev, action) => ({ ...prev, ...action.payload.data }),
  [ActionSuccessType(GET_EXPERT_GLOBAL_SETTINGS)]: (prev, action) => ({
    ...prev,
    ...action.payload.data,
  }),
  [ActionSuccessType(UPDATE_VACATION_MODE)]: (prev, action) => ({
    ...prev,
    vacation: action.payload.data,
  }),
  [ActionSuccessType(CREATE_TIME_SLOT)]: (prev, action) => ({ ...prev, availableTimeSlots: action.payload.data }),
  [ActionSuccessType(REMOVE_TIME_SLOT)]: (prev, action) => ({ ...prev, availableTimeSlots: action.payload.data }),
  [ActionSuccessType(UPDATE_EXPERT_AVAILABILITY)]: (prev, action) => ({
    ...prev,
    availability: action.payload.data?.availability,
    availableTimeSlots: action.payload.data?.timeSlots,
  }),
  [ActionSuccessType(UPDATE_CALENDAR_CONFIGURATIONS)]: (prev, action) => ({
    ...prev,
    calendarConnections: action.payload.data,
  }),
  [ActionSuccessType(DELETE_CALENDAR_ACCOUNT)]: (prev, action) => ({
    ...prev,
    calendarConnections: action.payload.data,
  }),
  [ActionSuccessType(UPDATE_GIFT_CARD_SETTING)]: (prev, action) => ({
    ...prev,
    ...action.payload.data,
  }),
  [ActionSuccessType(CREATE_SESSION)]: (prev, action) => ({ ...prev, sessions: action.payload.data }),
  [ActionSuccessType(UPDATE_SESSION)]: (prev, action) => ({ ...prev, sessions: action.payload.data }),
  [ActionSuccessType(DELETE_SESSION)]: (prev, action) => ({ ...prev, sessions: action.payload.data }),
  [ActionSuccessType(UPDATE_SESSION_SETTINGS)]: (prev, action) => ({ ...prev, ...action.payload.data }),
  [ActionSuccessType(CREATE_SESSION_PACK)]: (prev, action) => ({ ...prev, packages: action.payload.data }),
  [ActionSuccessType(UPDATE_SESSION_PACK)]: (prev, action) => ({ ...prev, packages: action.payload.data }),
  [ActionSuccessType(DELETE_SESSION_PACK)]: (prev, action) => ({ ...prev, packages: action.payload.data }),
  [ActionSuccessType(UPDATE_PAYOUT_METHOD)]: (prev, action) => ({ ...prev, payoutMethod: action.payload.data }),
  [ActionSuccessType(DISCONNECT_ZOOM_ACCOUNT)]: (prev) => omit(prev, ['zoomAccountName', 'zoomConfigurations']),
  [ActionSuccessType(UPDATE_ZOOM_CONFIGURATIONS)]: (prev, action) => ({
    ...prev,
    zoomConfigurations: action.payload.data,
  }),
  [ActionSuccessType(ENABLE_ZOOM_CO_HOST)]: (prev, action) => ({ ...prev, zoomConfigurations: action.payload.data }),
  [ActionSuccessType(GET_EXPERT_SESSIONS_SETTING)]: (prev, action) => ({
    ...prev,
    sessions: action.payload.data,
  }),
  [ActionSuccessType(GET_EXPERT_PACKAGES)]: (prev, action) => ({
    ...prev,
    packages: action.payload.data,
  }),
  [ActionSuccessType(UPDATE_CURRENCY_LIMITATIONS)]: (prev, action) => ({
    ...prev,
    ...action.payload.data,
  }),
  [ActionSuccessType(UPDATE_EXPERT_VISIBILITY)]: (prev, action) => ({ ...prev, ...action.payload.data }),
  [ActionSuccessType(GET_IN_PERSON_MEETING_LOCATIONS)]: (prev, action) => {
    let forSite = [];
    let forExpert = [];
    let available = [];

    action.payload.data.forEach((location) => {
      if (location.belongsToExpert) {
        forExpert.push(location);
      } else {
        forSite.push(location);
      }

      if (location.status === 'approved') {
        available.push(location);
      }
    });

    return {
      ...prev,
      inPersonMeetingLocationsForSetting: forExpert,
      inPersonMeetingLocationsForSite: forSite,
      inPersonMeetingLocations: available,
    };
  },

  [ActionSuccessType(UPDATE_IN_PERSON_MEETING_LOCATIONS)]: (prev, action) => ({
    ...prev,
    inPersonMeetingLocationsForSetting: action.payload.data,
  }),
  [ActionSuccessType(GET_EXPERT_AVAILABLE_STRIPE_ACCOUNTS)]: (prev, action) => ({
    ...prev,
    availableStripeAccounts: action.payload.data,
  }),
});

export default expertSettingsReducer;
